// https://stackoverflow.com/questions/17417607/angular-ng-bind-html-and-directive-within-it
// https://github.com/incuna/angular-bind-html-compile/blob/master/angular-bind-html-compile.js
angular.module("avlib").directive('compile', ['$compile', function ($compile) {
    return function(scope, element, attrs) {
        scope.$watch(
            function(scope) {
                // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
            },
            function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                
                var compileScope = scope;
                if (attrs.compileScope) {
                  compileScope = scope.$eval(attrs.compileScope);
                }
                
                $compile(element.contents())(compileScope);
            }
        );
    };
}]);


//app.directive('compile', ['$compile',
//  function($compile) {
//    return {
//      restrict: 'A',
//      link: function(scope, element, attrs) {
//	var code = scope.$eval(attrs.compile);
//	element.html(code);
//        $compile(element.contents())(scope);
//      }
//    }
//  }
//]);
